import { IllustrationPaperMissing } from '@bbl-digital/snorre'
import { Text } from '@bbl-digital/snorre-v2'

type NoContentProps = {
  /** Label to show in the no content state. Default text if not provided **/
  text?: string
  /** Illustration to show in the no content state. Default illustration if not provided **/
  illustration?: React.ReactNode
}

const NoContent = ({ text = 'Ingen treff', illustration }: NoContentProps) => {
  return (
    <div className="flex flex-col justify-center items-center mb-4">
      <div className="flex justify-center items-center">
        {illustration || (
          <IllustrationPaperMissing width="200px" height="200px" />
        )}
      </div>
      <Text weight="bold">{text}</Text>
    </div>
  )
}

export default NoContent
